export default "__VITE_ASSET__b3G66X9a__"